"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PumaClient = exports.mkPageViewData = exports.mkImpressionData = exports.mkPumaClient = void 0;
var send_utils_1 = require("./utils/send.utils");
var random_utils_1 = require("./utils/random.utils");
var impression_utils_1 = require("./utils/impression.utils");
Object.defineProperty(exports, "mkImpressionData", { enumerable: true, get: function () { return impression_utils_1.mkImpressionData; } });
var view_utils_1 = require("./utils/view.utils");
Object.defineProperty(exports, "mkPageViewData", { enumerable: true, get: function () { return view_utils_1.mkPageViewData; } });
var PumaClient = /** @class */ (function () {
    function PumaClient(session_id, url, subdomain, product_name, rockman_id, impression_time) {
        this.session_id = session_id;
        this.url = url;
        this.subdomain = subdomain;
        this.product_name = product_name;
        this.rockman_id = undefined;
        this.impression_time = Date.now();
        if (typeof rockman_id === "string")
            this.rockman_id = rockman_id;
        if (typeof impression_time === "number")
            this.impression_time = impression_time;
    }
    PumaClient.prototype.mkInteractionBody = function (data, rockman_id) {
        var event_category = data.event_category, event_type = data.event_type, args = data.args;
        var body = {
            r: rockman_id || this.rockman_id,
            s: this.session_id,
            m: random_utils_1.rand(),
            d: [
                {
                    t: "interaction",
                    s: random_utils_1.rel(this.impression_time),
                    a: __assign({ event_category: event_category,
                        event_type: event_type }, args),
                },
            ],
        };
        return body;
    };
    PumaClient.prototype.mkImpressionBody = function (a) {
        // when rockman_id is present in URL
        var rockman_id1 = new URL(a.url).searchParams.get("rid");
        var rockman_id2 = new URL(a.url).searchParams.get("rockman_id");
        var body = {
            r: this.rockman_id || rockman_id1 || rockman_id2,
            s: this.session_id,
            m: random_utils_1.rand(),
            d: [
                {
                    t: "impression",
                    a: __assign(__assign({}, a), { product_name: this.product_name, subdomain: this.subdomain }),
                },
            ],
        };
        return body;
    };
    PumaClient.prototype.mkPageViewBody = function (data, rockman_id) {
        return {
            r: rockman_id || this.rockman_id,
            s: this.session_id,
            m: random_utils_1.rand(),
            d: [
                {
                    t: "pageview",
                    s: random_utils_1.rel(this.impression_time),
                    a: data,
                },
            ],
        };
    };
    PumaClient.prototype.updateClient = function (data) {
        var rockman_id = data.rockman_id, impression_time = data.impression_time, subdomain = data.subdomain, product_name = data.product_name;
        if (typeof rockman_id === "string")
            this.rockman_id = rockman_id;
        if (typeof impression_time === "number")
            this.impression_time = impression_time;
        if (typeof subdomain === "string")
            this.subdomain = subdomain;
        if (typeof product_name === "string")
            this.product_name = product_name;
    };
    PumaClient.prototype.sendInteractionData = function (data, rockman_id) {
        var body = this.mkInteractionBody(data, rockman_id);
        send_utils_1.sendData({ method: "POST", url: this.url, data: body }).catch(function (e) { return console.log(e); });
    };
    PumaClient.prototype.sendImpressionData = function (data, f) {
        var _this = this;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, ip, ip_country_code, body, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, f()];
                    case 1:
                        _a = _b.sent(), ip = _a.ip, ip_country_code = _a.ip_country_code;
                        body = this.mkImpressionBody(__assign(__assign({}, data), { ip: ip, ip_country_code: ip_country_code }));
                        send_utils_1.sendData({ method: "POST", url: this.url, data: body }).catch(function (e) { return console.log(e); });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        send_utils_1.sendData({ method: "POST", url: this.url, data: this.mkImpressionBody(data) }).catch(function (e) { return console.log(e); });
                        console.log(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
    };
    PumaClient.prototype.sendPageViewData = function (data, rockman_id) {
        var body = this.mkPageViewBody(data, rockman_id);
        send_utils_1.sendData({ method: "POST", url: this.url, data: body }).catch(function (e) { return console.log(e); });
    };
    return PumaClient;
}());
exports.PumaClient = PumaClient;
var mkPumaClient = function (_a) {
    var session_id = _a.session_id, rockman_id = _a.rockman_id, url = _a.url, product_name = _a.product_name, subdomain = _a.subdomain, impression_time = _a.impression_time;
    return new PumaClient(session_id, url, subdomain, product_name, rockman_id, impression_time);
};
exports.mkPumaClient = mkPumaClient;
